(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prime-halloween"] && !Shopify.designMode) return;
  try {
    
function initPrimeHalloween(scope) {
  scope.querySelectorAll('[data-halloween]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const pilot = root.closest('.shopify-section')?.nextElementSibling?.querySelector('[data-tpv20-root]');
    const partyDate = root.dataset.halloweenDate;
    if (pilot && /^\d{4}-\d{2}-\d{2}$/.test(partyDate || '')) {
      const preset = new MutationObserver(() => {
        const date = pilot.querySelector('[data-tpv20-field="date"]');
        if (!date) return;
        preset.disconnect();
        if (partyDate < date.min) return;
        date.value = partyDate;
        date.dispatchEvent(new Event('input', {bubbles: true}));
        date.dispatchEvent(new Event('change', {bubbles: true}));
      });
      preset.observe(pilot, {childList: true, subtree: true});
    }
    root.addEventListener('change', event => {
      if (!event.target.matches('input[name="id"]')) return;
      root.querySelectorAll('[data-halloween-price]').forEach(price => { price.hidden = price.dataset.halloweenPrice !== event.target.value; });
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initPrimeHalloween(document));
else initPrimeHalloween(document);
document.addEventListener('shopify:section:load', event => initPrimeHalloween(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prime-order-path"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
  const link=event.target.closest('[data-prime-scroll-pilot]');
  if(!link)return;
  const section=link.closest('[data-prime-order-path]');
  if(!section)return;
  const pilot=document.querySelector('[data-tpv20-root], [data-central-calculator="true"]');
  if(!pilot)return;
  event.preventDefault();
  pilot.scrollIntoView({behavior:'smooth',block:'start'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-versorgung-cta"] && !Shopify.designMode) return;
  try {
    
(() => {
  const track = (root) => {
    const link = root.querySelector('[data-tp-supply-cta]');
    if (!link || link.dataset.tracked === 'true') return;
    link.dataset.tracked = 'true';
    link.addEventListener('click', () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'tp_supply_autopilot_cta_click',
        source_page: window.location.pathname
      });
    });
  };

  document.querySelectorAll('.tp-supply-cta').forEach(track);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('.tp-supply-cta').forEach(track);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
